import request from './services/axios.js'

// 书刊专辑接口

export default {
  //新建专辑
  setBookShelf: (albumName, userName) => {
    return request({
      url: 'ebook/addAlbum?albumName=' + albumName + '&userName=' + userName,
      method: 'POST'
    })
  },
  //获取专辑列表
  getBookShelfList: (params) => {
    return request({
      params,
      url: 'ebook/getAlbums',
      method: 'GET'
    })
  },
  //获取专辑列表
  getMobileBookShelfList: (pageNo, pageSize, userName) => {
    return request({
      url: 'ebook/mobile/getAlbums?pageNo=' + pageNo + '&pageSize=' + pageSize + '&username=' + userName,
      method: 'GET'
    })
  },
  //专辑编辑
  BookShelfEdit: (param) => {
    return request({
      data: param,
      url: 'ebook/editAlbum',
      method: 'POST'
    })
  },
  //删除专辑
  delBookShelf: (ids) => {
    return request({
      url: 'ebook/delAlbum?ids=' + ids,
      method: 'GET'
    })
  },
  //编辑专辑页已选书刊数据
  choiceAlready: (params) => {
    return request({
      url: 'ebook/getSelectedEbookByPage?pageNo=' + params.pageNo + '&pageSize=' + params.pageSize + '&albumId=' + params.albumId + '&title=' + params.title,
      method: 'GET'
    })
  },
  //编辑专辑页待选书刊数据
  choiceStay: (params) => {
    return request({
      url: 'ebook/getUnSelectedEbookByPage?pageNo=' + params.pageNo + '&pageSize=' + params.pageSize + '&albumId=' + params.albumId + '&title=' + params.title,
      method: 'GET'
    })
  },
  // 快速切换报刊
  quickSwitchBooks: (params) => {
    return request({
      params,
      url: 'ebook/canSwitchNewsPaper',
      method: 'GET'
    })
  }
}
